import { useRetryStage, useTriggerRescrape } from "@/hooks/use-pipeline";
import { useState } from "react";

export function TriggerPanel() {
  const trigger = useTriggerRescrape();
  const retry = useRetryStage();
  const [groupId, setGroupId] = useState("");

  return (
    <div className="iris-card" style={{ padding: "16px 20px" }}>
      <h3 className="iris-h3" style={{ fontSize: 14, margin: "0 0 12px" }}>
        Manual Triggers
      </h3>
      <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
        <input
          value={groupId}
          onChange={(e) => setGroupId(e.target.value)}
          placeholder="Group ID (e.g. tg_news_intl)"
          className="iris-input"
          style={{ flex: 1 }}
        />
        <button
          type="button"
          className="iris-btn"
          disabled={!groupId || trigger.isPending}
          onClick={() => trigger.mutate(groupId)}
        >
          Re-scrape
        </button>
        <button
          type="button"
          className="iris-btn"
          disabled={!groupId || retry.isPending}
          onClick={() => retry.mutate({ stage: "translate", group_id: groupId })}
        >
          Retry Failed
        </button>
      </div>
    </div>
  );
}
